import { MediaDownloadDto, MediaUploadDto } from 'collaboration-service';
import LabelInfo from 'components/LabelInfo';
import { MediaType } from 'components/MediaSelection/FileSelector';
import MediaSelection, { MSProps } from 'components/MediaSelection/MediaSelection';
import { belowBreakpointOrEqual, Label } from 'imaginarity-react-ui';
import * as React from 'react';
import { useImgI18N } from 'services/ImgI18N';
import { ThemeContext } from 'styled-components';
import { EPLContainer, EPLEditContainer, EPLLabelContainer } from '../EditPartLabelAndEditor';
import { BaseEditItem } from '../GeneralPostEdit';
import { useGPEState } from '../Helpers/UseGPEState';
import { PostEditElementProps } from '../TypeImplementations/PostEdit';

interface EditMediaProps<T> extends PostEditElementProps<T, MediaDownloadDto>, Partial<Pick<MSProps<MediaDownloadDto>, "uploadType" | "imgAspect">> {
    label?: string;
    minimized?: boolean;
    description?: string;
    disableLabel?: boolean;
    width?: string;
}

const EditMedia = <T extends BaseEditItem = BaseEditItem>(p: EditMediaProps<T>) => {
    const { uploadType, imgAspect, label, minimized, description, disableLabel, width } = p;
    const { value, setValue, addFile, resetValue } = useGPEState(p.getter);
    const { t } = useImgI18N("admin");
    const theme = React.useContext(ThemeContext);
    const isSmallDevice = belowBreakpointOrEqual({ theme }, "mobile");
    const set = React.useMemo(() => (file: File | undefined, media: MediaUploadDto) => {
        (media as any).file = file ? file : null;
        addFile();
        setValue(media as MediaDownloadDto);
    }, [setValue, addFile]);
    return (
        <EPLContainer minimized={minimized} style={{ gridTemplateColumns: isSmallDevice ? "1fr" : undefined }}>
            {!disableLabel && <EPLLabelContainer>
                <Label content={label ?? "select media"} icon="image" />
                {description &&
                    <LabelInfo infoText={t(description)} />
                }
            </EPLLabelContainer>}
            <EPLEditContainer style={disableLabel ? { gridColumnStart: 1, gridColumnEnd: 3 } : undefined} >
                <MediaSelection
                    width={width ?? "100%"}
                    media={value}
                    onMediaSelected={set}
                    showPlaceholderImage
                    imgAspect={imgAspect}
                    uploadType={uploadType ?? MediaType.ALL}
                    // width="355px"
                    onDelete={() => set(undefined, { ...value, changed: true })}
                    additionalButtons={[{
                        icon: "undo",
                        onClick: resetValue, kind: "tertiary",
                        content: t("reset")
                    }]}
                />
            </EPLEditContainer>
        </EPLContainer>
    );
}
export default EditMedia;